import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";
import FilterSelectApi from "../FilterSelectApi";

function FilterDMXE({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    nha_xe: null,
    bien_so: "",
    loai_xe: null,
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.nha_xe) {
      condition.nha_xe = filter.nha_xe?.ma_dt;
    }
    if (filter.bien_so) {
      condition.bien_so = { $regex: filter.bien_so, $options: "i" };
    }
    if (filter.loai_xe) {
      condition.type = filter.loai_xe?._id;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        label="Biển số"
        placeholder="Tìm theo biển số xe"
        value={filter.bien_so}
        onSearch={(val) => setFilter({ ...filter, bien_so: val })}
      />
      <FilterSelectApi
        label="Nhà xe"
        placeholder="Chọn nhà xe"
        selectTitle="Chọn nhà xe"
        placeholderSearch="Tìm theo mã, tên nhà xe"
        apiCode="dmnhaxe"
        getOptionLabel={(option) => option.ten_dt}
        checkEqual={(value, option) => value?.ma_dt === option?.ma_dt}
        searchFields={["ma_dt", "ten_dt"]}
        value={filter.nha_xe}
        onChange={(val) => setFilter({ ...filter, nha_xe: val })}
      />
      <FilterSelectApi
        label="Loại xe"
        placeholder="Chọn loại xe"
        selectTitle="Chọn loại xe"
        placeholderSearch="Tìm theo tên loại xe"
        apiCode="dmloaixe"
        getOptionLabel={(option) => option.name}
        checkEqual={(value, option) => value?._id === option?._id}
        searchFields={["name"]}
        value={filter.loai_xe}
        onChange={(val) => setFilter({ ...filter, loai_xe: val })}
      />
    </WrapperFilter>
  );
}

export default FilterDMXE;
